export function getBrowser() {
  const ua = window.navigator.userAgent || "";
  // const ua = "Mozilla/5.0 (iPhone; CPU iPhone OS 16_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 platform=ios&version=1.8.24&applicationId=com.lhy.getpro.dev&X-channel-id=&tradeGo=http://172.16.30.232:31001&getH5Url=http://172.16.30.207:10192&statementUrl=http://172.16.30.232:10481&gfPhpUrl=http://172.16.30.232:10481&getPhpUrl=http://172.16.30.207:10689&saasPhpUrl=http://172.16.30.207:10689&AirmGoUrl=http://172.16.30.207:10689&goUrl=http://172.16.30.207:10689&tradeUrl=http://172.16.30.207:10689&saasGoUrl=http://172.16.30.207:10689"
  const isAndroid = /android/i.test(ua);
  const isIos = /iphone|ipad|ipod/i.test(ua);
  const isWechat = /micromessenger\/([\d.]+)/i.test(ua);
  const isWeibo = /(weibo).*weibo__([\d.]+)/i.test(ua);
  const isQQ = /qq\/([\d.]+)/i.test(ua);
  const isQQBrowser = /(qqbrowser)\/([\d.]+)/i.test(ua);
  const isQzone = /qzone\/.*_qz_([\d.]+)/i.test(ua);
  // 安卓 chrome 浏览器，很多 app 都是在 chrome 的 ua 上进行扩展的
  const isOriginalChrome =
    /chrome\/[\d.]+ Mobile Safari\/[\d.]+/i.test(ua) && isAndroid;
  // chrome for ios 和 safari 的区别仅仅是将 Version/<VersionNum> 替换成了 CriOS/<ChromeRevision>
  // ios 上很多 app 都包含 safari 标识，但它们都是以自己的 app 标识开头，而不是 Mozilla
  const isSafari =
    /safari\/([\d.]+)$/i.test(ua) &&
    isIos &&
    ua.indexOf("Crios") < 0 &&
    ua.indexOf("Mozilla") === 0;

  const isAndroidApp = ua.indexOf("platform=android") > -1;

  const isIosApp = ua.indexOf("platform=ios") > -1;

  const isApp = /platform=(ios|android)/i.test(ua);

  const isIdcApp = ua.indexOf('applicationId=com.lhy.idc') > -1;// 判断是否是idc app
  const isGetProApp = ua.indexOf('applicationId=com.lhy.getpro') > -1;// 判断是否是get Pro app
  
  let star = ua.indexOf('&')+1
  let objArr = ua.substring(star).split('&')
  let getH5Url;
  let idcUrl;
  /** App WebView 注入的统一网关（http / wss） */
  let apiHost;
  let wsHost;
  let appVersion;
  objArr.forEach((item)=>{
    let num = item.indexOf('=')+1 || 0
    if(item.indexOf("getH5Url") > -1){
      getH5Url = item.substring(num);
    }else if(item.indexOf("idcUrl") > -1){
      idcUrl = item.substring(num);
    }else if(/^version=/i.test(item)){
      appVersion = item.substring(num);
    }else if(/^apiHost=/i.test(item) || /^httpHost=/i.test(item)){
      apiHost = item.substring(num);
    }else if(/^wsHost=/i.test(item) || /^wssHost=/i.test(item)){
      wsHost = item.substring(num);
    }
  })

  return {
    isAndroid,
    isIos,
    isWechat,
    isWeibo,
    isQQ,
    isQQBrowser,
    isQzone,
    isOriginalChrome,
    isSafari,
    isApp,
    isAndroidApp,
    isIosApp,
    isIdcApp,
    isGetProApp,

    getH5Url,
    idcUrl,
    apiHost,
    wsHost,
    /** UA 中 version=1.5.36，App 壳版本 */
    appVersion
  };
}
